import { useState } from "react"
import Image from "next/image"
import { usePathData } from "@/lib/contexts/appContext"
import Block from "@/components/wrappers/block"
import styles from "./google-maps.module.css"
import BlockHeader from "@/common/partials/block-header/block-header"
import Spinner from "@/components/common/logos/spinner"
import classNames from "classnames"

export default function GoogleMaps({ block }) {
  const { template } = usePathData()
  const {
    address,
    type,
    embed,
    iframe,
    zoom,
    size,
    format,
    width,
    height,
    blockGap
  } = block.attrs

  if (
    type === "iframe" &&
    !iframe.startsWith('<iframe src="https://www.google.com/maps/embed')
  ) {
    return null
  }

  return (
    <Block
      width={block.attrs.size === "small" ? "column" : block.attrs.size}
      gap={template === "article" ? "small" : blockGap}
      block={block}
      className={styles.map}>
      <BlockHeader heading={block?.attrs?.heading} text={block?.attrs?.text} />
      {type === "query" && (
        <Media {...{ address, zoom, size, format, width, height }} />
      )}
      {type === "embed" && (
        <Iframe {...{ embed, size, format, width, height }} />
      )}
      {type === "iframe" && (
        <div
          className={"format-" + format.replace(":", "-")}
          dangerouslySetInnerHTML={{ __html: iframe }}></div>
      )}
    </Block>
  )
}

export function Media({ address, zoom, format, width, height }) {
  const mapKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY
  const [state, setState] = useState("loading")

  const query =
    new URLSearchParams({
      key: mapKey,
      zoom: zoom,
      scale: 2,
      size: width / 2 + "x" + height / 2,
      markers: address
    }).toString() + "&style=feature:water|geometry.fill|color:0xa0b5d5"

  const src =
    address.length > 0
      ? "https://maps.googleapis.com/maps/api/staticmap?" + query
      : null

  if (!src) {
    return null
  }

  const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    address
  )}`

  return (
    <a href={mapsUrl} target="_blank" rel="noopener noreferrer">
      <figure
        className={classNames(
          "google-map",
          state,
          "format-" + format.replace(":", "-")
        )}>
        {state === "loading" && (
          <div className="spinner">
            <Spinner className="w-8 h-8 opacity-25" />
          </div>
        )}
        <Image
          onLoad={() => setState(false)}
          className={styles.map}
          width={width}
          height={height}
          alt={"Karta till " + address}
          src={src}
        />
      </figure>
    </a>
  )
}

export function Iframe({ embed, height }) {
  if (!embed) {
    return null
  }

  return (
    <iframe
      src={embed}
      width="100%"
      height={height}
      style={{ border: 0 }}
      allowFullScreen=""
      aria-hidden="false"
      tabIndex="0"
    />
  )
}
